import { render } from "./LesHabituesPage.vue?vue&type=template&id=525f1738"
import script from "./LesHabituesPage.vue?vue&type=script&lang=js"
export * from "./LesHabituesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__